import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Button, Typography } from "@material-ui/core";

import {
  cambiarEstadoSolicitud,
  getBandejas,
  moverBandejaSolicitud,
  postEnviarSolicitud,
  setActiveStep,
  setAfiliadoSeleccionado,
  setRetomandoAppMobile,
  setShowForm,
} from "../../../../actions/autorizaciones/Autorizaciones";

import { AUTORIZACIONES_BANDEJAS, AUTORIZACIONES_MATERIALES_COMPRAS_ESTADOS, AUTORIZACIONES_SOLICITUDES_ESTADOS, STEPPER_AUTORIZACIONES, TIPOS_AUTORIZACIONES } from "../../../../utils/constants";
import { ModalNotas } from "./ModalNotas";
import { ModalFinalizarPractEnInter } from "./ModalFinalizarPractEnInter";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { AUTORIZACIONES_PERMISOS } from "../../../../utils/permisos";
import { startAlerta } from "../../../../actions/ui/alertas";
import { ModalToken } from "./ModalToken";

export const AdministrarMenu = (props) => {
  const dispatch = useDispatch();

  const { bandejas = [], solicitudSeleccionada = {} } = useSelector(
    (state) => state.autorizaciones
  );

  const { permisos: permisosUser } = useSelector(state => state.auth);

  const [openModalNotas, setOpenModalNotas] = useState(false);
  const [openModalToken, setOpenModalToken] = useState(false);
  const [openModalNotasBandeja, setOpenModalNotasBandeja] = useState(false);
  const [openModalPracticaEnInternacion, setOpenModalPracticaEnInternacion] = useState(false);
  const [idBandejaAutorizacion, setIdBandejaAutorizacion] = useState(false);
  const [idEstadoSolicitudNota, setIdEstadoSolicitudNota] = useState(false);

  useEffect(() => {
    dispatch(getBandejas());
  }, []);

  const permisoAutorizarAfiBaja = validarSoloUnPermiso(permisosUser, AUTORIZACIONES_PERMISOS.AUTORIZAR_AFILIADOS_BAJA)

  const onClickCambiarBandeja = (idBandeja) => {
    const data = {
      idSolicitud: solicitudSeleccionada.idSolicitud,
      idBandejaAutorizacion: idBandeja,
    };

    if (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.PRACTICAS_EN_INTERNACION
      && (idBandeja === AUTORIZACIONES_BANDEJAS.COMPRAS || idBandeja === AUTORIZACIONES_BANDEJAS.CONTRATOS)) {
      setIdBandejaAutorizacion(idBandeja);
      setOpenModalNotasBandeja(true);
    } else {
      dispatch(moverBandejaSolicitud(data, props.closeModalAuditar, props.filtros));
    }
  };

  const onClickCambiarEstadoSolicitud = (idEstadoSolicitud) => {
    const data = {
      idSolicitud: solicitudSeleccionada.idSolicitud,
      idEstadoSolicitud
    };

    if (solicitudSeleccionada?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES
      && idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA
      && solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PRACTICAS_EN_INTERNACION
      && solicitudSeleccionada?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.CONTRATOS
      && existeMaterialConEstadoCompraPresupuesto
    ) {
      setOpenModalPracticaEnInternacion(true);
    } else if (idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION ||
      idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION_APP ||
      idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.RECHAZADA) {
      setIdEstadoSolicitudNota(idEstadoSolicitud);
      setOpenModalNotas(true);
    } else {
      if ((solicitudSeleccionada?.afiliado?.fecha_baja !== null || solicitudSeleccionada?.afiliado?.sinFichaAfiliacion !== false)
        && idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA) {
        if (solicitudSeleccionada?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE) {
          if (permisoAutorizarAfiBaja) {
            setOpenModalToken(true)
          }
          else {
            dispatch(startAlerta("Para autorizar una solicitud de afiliado baja o suspendido debe solicitar el permiso al jefe del area.", "error"))
          }
        }
        else {
          dispatch(cambiarEstadoSolicitud(data, props.closeModalAuditar, props.filtros));
        }
      }
      else {
        dispatch(cambiarEstadoSolicitud(data, props.closeModalAuditar, props.filtros));
      }
    }
  };

  const onClickEnviarSolicitud = () => {
    dispatch(postEnviarSolicitud(solicitudSeleccionada.idSolicitud, solicitudSeleccionada.urgente, false, false,
      props.closeModalAuditar, props.filtros
    ));
  };

  const existeMaterialConEstadoCompraPresupuesto = solicitudSeleccionada?.practicas?.some(practica =>
    practica.materiales?.some(material => material.idEstadoCompraMaterial === AUTORIZACIONES_MATERIALES_COMPRAS_ESTADOS.PRESUPUESTO)
  );

  const cambiarEstadoSolicitudPostToken = () => {
    const data = {
      idSolicitud: solicitudSeleccionada.idSolicitud,
      idEstadoSolicitud: AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA
    };
    dispatch(cambiarEstadoSolicitud(data, props.closeModalAuditar, props.filtros));
  };

  const postIrASolicitud = (item) => {
    dispatch(setRetomandoAppMobile());
    props.setRedirect(true);
    //dispatch(setSolicitud(item));
    dispatch(setAfiliadoSeleccionado(solicitudSeleccionada.afiliado));
    dispatch(setShowForm(true));
    //dispatch(setActiveBreadcrumb(MENU_AUTORIZACIONES.INGRESO_AUTORIZACION));
    dispatch(setActiveStep(STEPPER_AUTORIZACIONES.DETALLES_ORDEN));
    console.log("item", item)
  };

  return (
    <React.Fragment>
      {openModalToken && (
        <ModalToken
          open={openModalToken}
          close={() => {
            setOpenModalToken(false);
          }}
          //desdeIngresoSolicitud={false}
          solicitudSeleccionada={solicitudSeleccionada}
          disabled={false}
          titulo={"Validacíon Token"}
          //closeModalAuditar={props.closeModalAuditar}
          filtros={props.filtros}
          cambiarEstadoSolicitudPostToken={cambiarEstadoSolicitudPostToken}
        />
      )}
      {solicitudSeleccionada?.idBandejaAutorizacion !== AUTORIZACIONES_BANDEJAS.AFILIACIONES &&
        <Typography
          variant="h6"
          style={{
            textAlign: "center",
            margin: "1.5rem 0",
          }}
        >
          Mover Bandeja:
        </Typography>}
      {solicitudSeleccionada?.idBandejaAutorizacion !== AUTORIZACIONES_BANDEJAS.AFILIACIONES &&
        Array.isArray(bandejas) && bandejas.length > 0 && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              flexWrap: "wrap",
            }}
          >
            {bandejas?.filter(item =>
              (solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PRACTICAS_EN_INTERNACION
                && solicitudSeleccionada?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES
                && existeMaterialConEstadoCompraPresupuesto ?
                true
                : item.idBandeja !== AUTORIZACIONES_BANDEJAS.CONTRATOS && item.idBandeja !== AUTORIZACIONES_BANDEJAS.COMPRAS
              ) &&
              item.idBandeja !== AUTORIZACIONES_BANDEJAS.AUDITOR_PRESUPUESTOS &&
              item.idBandeja !== AUTORIZACIONES_BANDEJAS.FISIATRIA &&
              /*item.idBandeja !== AUTORIZACIONES_BANDEJAS.JEFATURA_AUDITORIA_MEDICA &&*/
              item.idBandeja !== AUTORIZACIONES_BANDEJAS.INTERNACION_PAIS &&
              item.idBandeja !== AUTORIZACIONES_BANDEJAS.AUDITORIA_TERRENO &&
              item.idBandeja !== solicitudSeleccionada?.idBandejaAutorizacion /*Oculto la bandeja en donde se encuenta la Solicitud*/
            ).map((bandeja) => {
              return (
                <Button
                  key={bandeja.idBandeja.toString()}
                  style={{ margin: "0.5rem", flexBasis: "30%" }}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    onClickCambiarBandeja(bandeja.idBandeja);
                  }}
                >
                  {bandeja.descripcion}
                </Button>
              );
            })}
          </div>
        )}
      {solicitudSeleccionada.idTipoSolicitud !==
        TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
        <Typography
          variant="h6"
          style={{
            textAlign: "center",
            margin: "1.5rem 0",
          }}
        >
          Cambiar Estado Solicitud:
        </Typography>
      }
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          flexWrap: "wrap",
        }}
      >
        {openModalNotas && (
          <ModalNotas
            open={openModalNotas}
            close={() => {
              setOpenModalNotas(false);
            }}
            desdeIngresoSolicitud={false}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            disabled={false}
            titulo={"Agregar Nota"}
            nota={null}
            tipoNotaDisabled={true}
            idEstadoSolicitud={idEstadoSolicitudNota}
            closeModalAuditar={props.closeModalAuditar}
            filtros={props.filtros}
          />
        )}
        {openModalNotasBandeja && (
          <ModalNotas
            open={openModalNotasBandeja}
            close={() => {
              setOpenModalNotasBandeja(false);
            }}
            desdeIngresoSolicitud={false}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            disabled={false}
            titulo={"Agregar Nota"}
            nota={null}
            tipoNotaDisabled={true}
            idEstadoSolicitud={false}
            idBandejaAutorizacion={idBandejaAutorizacion}
            closeModalAuditar={props.closeModalAuditar}
            filtros={props.filtros}
          />
        )}
        {openModalPracticaEnInternacion && (
          <ModalFinalizarPractEnInter
            open={openModalPracticaEnInternacion}
            close={() => {
              setOpenModalPracticaEnInternacion(false);
            }}
            desdeIngresoSolicitud={false}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            disabled={false}
            titulo={"Finalizar Practicas en Internacion"}
            nota={null}
            tipoNotaDisabled={true}
            idEstadoSolicitud={AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA}
            idBandejaAutorizacion={false}
            closeModalAuditar={props.closeModalAuditar}
            filtros={props.filtros}
          />
        )}
        {solicitudSeleccionada.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA &&
          solicitudSeleccionada.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION &&
          solicitudSeleccionada?.idBandejaAutorizacion !== AUTORIZACIONES_BANDEJAS.AFILIACIONES &&
          (
            <Button
              style={{
                margin: "0.5rem",
                flexBasis: "30%",
                backgroundColor: "orange",
                color: "white",
              }}
              variant="contained"
              onClick={() =>
                onClickCambiarEstadoSolicitud(
                  AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION
                )
              }
            >
              Devolución
            </Button>
          )}
        {(solicitudSeleccionada.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION
          || solicitudSeleccionada.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE) &&
          solicitudSeleccionada?.fromAppMobile &&
          (
            <Button
              style={{
                margin: "0.5rem",
                flexBasis: "30%",
                backgroundColor: "orange",
                color: "white",
              }}
              variant="contained"
              onClick={() =>
                onClickCambiarEstadoSolicitud(
                  AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION_APP
                )
              }
            >
              Devolución al afiliado
            </Button>
          )}
        {solicitudSeleccionada.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION &&
          solicitudSeleccionada?.fromAppMobile &&
          (
            <Button
              style={{
                margin: "0.5rem",
                flexBasis: "30%",
                backgroundColor: "blue",
                color: "white",
              }}
              variant="contained"
              onClick={() =>
                postIrASolicitud(solicitudSeleccionada)
              }
            >
              Retomar Carga
            </Button>
          )}
        {solicitudSeleccionada.idTipoSolicitud !== TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
          solicitudSeleccionada?.idBandejaAutorizacion !== AUTORIZACIONES_BANDEJAS.AFILIACIONES &&
          solicitudSeleccionada?.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION &&
          <Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "green",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickCambiarEstadoSolicitud(
                AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA
              )
            }
          >
            Finalizar
          </Button>
        }
        {(solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PASAJES ||
          solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.ESTADIAS) &&
          <Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "red",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickCambiarEstadoSolicitud(
                AUTORIZACIONES_SOLICITUDES_ESTADOS.RECHAZADA
              )
            }
          >
            Rechazar
          </Button>
        }
        {solicitudSeleccionada?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.AFILIACIONES &&
          <Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "green",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickEnviarSolicitud()
            }
          >
            Enviar
          </Button>
        }
      </div>
    </React.Fragment>
  );
};
